module.exports = __webpack_public_path__ + "img/dex-pwa-browser.b2d4f8f7.svg";